import { DataObject } from '@app/_shared/interfaces';
import { FeatureFlag } from '@app/_shared/interfaces/http/companies/feature-flag';
import { pipe } from 'rxjs';
import { map } from 'rxjs/operators';

export const checkFeatureFlag = (key: string) =>
  pipe(map((featureFlags: DataObject<FeatureFlag>[]) => featureFlags.some((flag) => flag.attributes.key === key)));
